import { ICategoryResponse } from "@/types/category.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";

export const getNewsCategories = (locale: string): Promise<ICategoryResponse> => {
  return fetch(
    `${BASE_URL}/news-categories?locale=${encodeURIComponent(locale)}&populate[0]=localizations`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: ICategoryResponse) => {
      return data;
    });
};
